import { Routes, Route } from 'react-router-dom';
import { Box } from '@primer/react';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ThemeToggle from './components/ThemeToggle';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import HowWeWork from './pages/HowWeWork';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import WorkDetail from './pages/WorkDetail';

function App() {
  return (
    <Box sx={{ backgroundColor: 'canvas.default', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <ScrollToTop />
      <Header />
      <Box sx={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/how-we-work" element={<HowWeWork />} />
          <Route path="/insights" element={<Blog />} />
          <Route path="/insights/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/work/:slug" element={<WorkDetail />} />
        </Routes>
      </Box>
      <Footer />

      <Box sx={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 200 }}>
        <ThemeToggle />
      </Box>
    </Box>
  );
}

export default App;
